// extracted by mini-css-extract-plugin
module.exports = {"openDoors":"OpenDoors_openDoors__1yNFO","center":"OpenDoors_center__3oc5i"};